module.exports = __webpack_public_path__ + "static/media/nHJVduZpUl.cf0020b1.jpg";